<template>
  <MallBottomSheet @close="$emit('close')">
    <div class="mall-purchase-info-sheet__content">
      <span class="typo-lg-semi">구매정보를 확인해 주세요</span>

      <!-- 처방일수 입력 -->
      <MallTextField
        v-model="form.prescriptionDays"
        :label="'처방일수 입력'"
        :required="true"
        :inputmode="'numeric'"
        :placeholder="'처방일수를 입력해 주세요'"
      />

      <div class="mall-purchase-info-sheet__divider"></div>

      <!-- 경감 대상 선택 -->
      <div class="mall-purchase-info-sheet__field mall-purchase-info-sheet__field--chips">
        <MallFieldLabel :label="'경감 대상 선택'" :required="true" />
        <div class="mall-purchase-info-sheet__chips">
          <div
            v-for="option in reductionOptions"
            :key="option.value"
            class="mall-purchase-info-sheet__chip"
            :class="{ 'mall-purchase-info-sheet__chip--selected': form.reductionType === option.value }"
            @click="form.reductionType = option.value"
          >
            {{ option.label }}
          </div>
        </div>
      </div>

      <div class="mall-purchase-info-sheet__divider"></div>

      <!-- 인슐린펌프 사용 여부 -->
      <div class="mall-purchase-info-sheet__field">
        <MallFieldLabel :label="'인슐린펌프 사용 여부'" :required="true" />
        <div class="mall-purchase-info-sheet__checkbox-row" @click="form.usesInsulinPump = !form.usesInsulinPump">
          <MallCheckBox :checked="form.usesInsulinPump" />
          <span class="typo-body-m-medium mall-purchase-info-sheet__checkbox-text">미니메드 780G 사용</span>
        </div>
        <span class="mall-purchase-info-sheet__helper">만 19세 미만 미니메드 780G 인슐린펌프 사용자의 경우 공단 지원금이 다를 수 있습니다.</span>
      </div>

      <div class="mall-purchase-info-sheet__notice">
        <div class="mall-purchase-info-sheet__notice-icon">
          <img src="@/assets/mall/icn_info_fill.svg" alt="" />
        </div>
        <span class="mall-purchase-info-sheet__notice-text">공단지원 가능일은 솔닥 컨시어지에서 확인해요.<br />별도 요청사항이 있을 경우 안내해 드릴게요.</span>
      </div>
    </div>

    <template slot="buttons">
      <MallButton :label="'닫기'" :type="'secondary'" @click="$emit('close')" />
      <MallButton :label="'저장'" :type="'primary'" @click="$emit('save', form)" />
    </template>
  </MallBottomSheet>
</template>

<script>
import MallButton from '@/components/new/atoms/MallButton.vue'
import MallCheckBox from '@/components/new/atoms/MallCheckBox.vue'
import MallFieldLabel from '@/components/new/atoms/MallFieldLabel.vue'
import MallBottomSheet from '@/components/new/molecules/MallBottomSheet.vue'
import MallTextField from '@/components/new/molecules/MallTextField.vue'

export default {
  name: 'MallPurchaseInfoSheet',
  components: {
    MallButton,
    MallCheckBox,
    MallFieldLabel,
    MallBottomSheet,
    MallTextField,
  },
  props: {
    // { prescriptionDays, reductionType, usesInsulinPump }
    info: {
      type: Object,
      required: true,
    },
    // [{ value, label }]
    reductionOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      form: Object.assign({}, this.info),
    }
  },
  watch: {
    'form.prescriptionDays'(value) {
      var digits = String(value).replace(/[^0-9]/g, '')
      if (digits !== value) {
        this.form.prescriptionDays = digits
      }
    },
  },
}
</script>

<style scoped>
.mall-purchase-info-sheet__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mall-purchase-info-sheet__field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mall-purchase-info-sheet__field--chips {
  gap: 4px;
}

.mall-purchase-info-sheet__divider {
  flex-shrink: 0;
  height: 1px;
  background: #F2F4F6;
}

.mall-purchase-info-sheet__chips {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mall-purchase-info-sheet__chip {
  display: flex;
  height: 54px;
  padding: 0 12px;
  justify-content: center;
  align-items: center;
  border: 1px solid #E5E8EB;
  border-radius: 8px;
  background: #F9FAFB;
  box-sizing: border-box;
  color: #4E5968;
  font-family: Pretendard;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  white-space: nowrap;
  cursor: pointer;
}

.mall-purchase-info-sheet__chip--selected {
  border-color: #59BAFF;
  background: #EFF9FF;
  color: #0096FF;
}

.mall-purchase-info-sheet__checkbox-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
}

.mall-purchase-info-sheet__checkbox-text {
  color: #4E5968;
}

/* 13px 텍스트는 Figma 렌더링 기준(150% → 20px 반올림)으로 맞춤 */
.mall-purchase-info-sheet__helper {
  max-width: 296px;
  color: #0096FF;
  font-family: Pretendard;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  line-height: 20px;
}

.mall-purchase-info-sheet__notice {
  display: flex;
  flex-shrink: 0;
  padding: 16px 12px;
  align-items: flex-start;
  gap: 4px;
  border-radius: 12px;
  background: #F9FAFB;
}

.mall-purchase-info-sheet__notice-icon {
  display: flex;
  padding-top: 4px;
}

.mall-purchase-info-sheet__notice-icon img {
  display: block;
}

.mall-purchase-info-sheet__notice-text {
  flex: 1;
  min-width: 0;
  color: var(--color-text-sub);
  font-family: Pretendard;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallPurchaseInfoSheet.vue